import cx from 'classnames';
import { Breakpoint, ColConfig, ColConfigObject } from './types';
import { generateColClasses } from './utils';
import { ElementType, FC, forwardRef, DetailedHTMLProps, HTMLAttributes } from 'react';

export interface IColProps
  extends Partial<Record<Breakpoint, ColConfig>>,
    ColConfigObject,
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  tag?: ElementType;
}

const normalizeColConfig = (config?: ColConfig): ColConfigObject => {
  const configObject = typeof config === 'number' || config === 'auto' ? { size: config } : config || {};
  return configObject;
};

export const Col: FC<IColProps> = forwardRef(
  ({ size, order, className, style, grow, lg, xs, md, sm, tag, xl, smm, offset, ...restProps }, ref) => {
    const spanFields: ColConfigObject = normalizeColConfig({ size, grow, order, offset });

    const breakpointSpans: Record<Breakpoint, ColConfigObject> = {
      lg: normalizeColConfig(lg),
      xs: normalizeColConfig(xs),
      md: normalizeColConfig(md),
      smm: normalizeColConfig(smm),
      sm: normalizeColConfig(sm),
      xl: normalizeColConfig(xl)
    };

    const classes = cx(...generateColClasses(spanFields, breakpointSpans), className);

    const Tag = tag || 'div';

    return <Tag className={classes} style={style} {...restProps} ref={ref} />;
  }
);
